import React from 'react'
import { FormControl, InputLabel, Select, MenuItem, Typography } from '@material-ui/core'
import { Controller } from 'react-hook-form'
import { FieldError } from './FieldError'
import './FormFields.css'

interface SelectFieldProps {
  control: any
  label: string
  name: string
  error?: any
  defaultValue?: string
  rules?: any
  items: any[]
  id?: string
  inputProps?: any
  testId?: string
}

export const SelectField: React.FC<SelectFieldProps> = ({ control, label, name, error, defaultValue, rules, items, id, inputProps, testId }) => {
  return (
    <>
      <FormControl className="inputField" data-test={testId} id={id}>
        <InputLabel>{label}</InputLabel>
        <Controller
          name={name}
          defaultValue={defaultValue}
          control={control}
          rules={rules}
          as={
            <Select aria-label={label} inputProps={{ ...inputProps }}>
              {items.map((item: any) => (
                <MenuItem key={Math.random()} aria-label={item.label ? item.label : item} value={item.value ? item.value : item} data-test={item.testId ? item.testId : item}>
                  <Typography>{item.label ? item.label : item}</Typography>
                </MenuItem>
              ))}
            </Select>
          }
        />
      </FormControl>
      <FieldError fieldError={error} />
    </>
  )
}
